export default __webpack_public_path__ + "static/media/arrow-right-xs.243595a8.svg";